import type { FC, ImgHTMLAttributes } from 'react';
import styled from 'threads5/styles/styled';
import type SxProps from 'threads5/themes/sx-props';
import type { ITheme } from 'threads5/themes/theme';
import { breakpoints } from 'src/components-v2/theme';

type Breakpoint = keyof typeof breakpoints;

const StyledImg = styled('img')({});

const ResponsiveImage: FC<
  ImgHTMLAttributes<HTMLImageElement> & {
    srcs: Partial<Record<Breakpoint, string>>;
    sx?: SxProps<ITheme>;
  }
> = ({ sx, srcs, ...rest }) => {
  const fallbackSrc =
    srcs.xs ?? srcs.sm ?? srcs.md ?? srcs.lg ?? srcs.xl ?? srcs.xxl;

  return (
    <picture>
      {Object.entries(breakpoints)
        .sort(([, a], [, b]) => {
          return b - a;
        })
        .map(([name, minWidth]) => {
          if (!(name in srcs)) {
            return null;
          }
          return (
            <source
              key={name}
              srcSet={srcs[name as Breakpoint]}
              media={`(min-width: ${minWidth}px)`}
            />
          );
        })}
      <StyledImg sx={sx} src={fallbackSrc} {...rest} />
    </picture>
  );
};

export default ResponsiveImage;
